"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_1 = __importDefault(require("swr"));
var utils_1 = require("../utils");
/**
 * Gets and sets value to/from local storage.
 *
 * @param key key to get and set value to/from local storage.
 * @param defaultValue default value that is returned incase the key was not found.
 *
 * @returns an array of (the saved value, set value function, and remove value function) in the same order.
 */
var useLocalStorage = function (key, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    var initialValue = defaultValue;
    if (!utils_1.isServerSide()) {
        var storedValue = window.localStorage.getItem(key);
        if (storedValue !== null && storedValue !== 'undefined')
            initialValue = JSON.parse(storedValue);
    }
    var _a = swr_1.default(key, null, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshWhenHidden: false,
        refreshWhenOffline: false,
    }), _b = _a.data, value = _b === void 0 ? initialValue : _b, mutate = _a.mutate;
    // ========== Set value ==========
    var setValue = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var localStorageValue;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, mutate(value, false)];
                case 1:
                    _a.sent();
                    if (utils_1.isServerSide()) {
                        return [2 /*return*/];
                    }
                    localStorageValue = JSON.stringify(value);
                    window.localStorage.setItem(key, localStorageValue);
                    return [2 /*return*/];
            }
        });
    }); };
    // ========== Remove value ==========
    var removeValue = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, mutate(defaultValue, false)];
                case 1:
                    _a.sent();
                    if (utils_1.isServerSide()) {
                        return [2 /*return*/];
                    }
                    // Remove value from local storage
                    window.localStorage.removeItem(key);
                    return [2 /*return*/];
            }
        });
    }); };
    return [value, setValue, removeValue];
};
exports.default = useLocalStorage;
//# sourceMappingURL=useLocalStorage.js.map